import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

import './Document.scss';

function DocumentClaimsChunk({ chunk }) {
  const regxsToRemove = [/<Desc\/Clms.*?>/g];
  return (
    <InnerHTML
      tag="span"
      className="claims-chunk u-els-font-size-base u-els-line-height-default u-els-margin-right-2x"
      html={chunk}
      regxsToRemove={regxsToRemove}
    />
  );
}

DocumentClaimsChunk.propTypes = {
  chunk: PropTypes.string.isRequired,
};

export default DocumentClaimsChunk;
